import React from 'react';
import { C } from '../constants';
import { CheckIcon } from './Icons';

const POINTS = [
  'BSc-qualified Dispensing Optician',
  'Accurate prescription & lens dispensing',
  'Premium Farenheit and international frames',
  'Serving clients across Kasoa and Accra since 2021',
];

export default function About() {
  return (
    <section id="about" style={{ padding: '100px 5%', background: C.off }}>
      <div
        className="grid-2"
        style={{ maxWidth: '1200px', margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '80px', alignItems: 'center' }}
      >
        {/* Text side */}
        <div>
          <div style={{ display: 'inline-block', width: '36px', height: '1px', background: C.gold, marginBottom: '14px' }} />
          <h2 style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 'clamp(2rem,3.5vw,2.8rem)', fontWeight: 600, color: C.navy, marginBottom: '8px' }}>
            Meet Our Optician
          </h2>
          <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.15rem', color: C.gold, fontWeight: 400, letterSpacing: '0.05em', marginBottom: '20px' }}>
            Christian Da-Costa, BSc — Dispensing Optician
          </div>
          <p style={{ color: C.muted, fontSize: '0.93rem', lineHeight: 1.9, marginBottom: '16px', fontWeight: 300 }}>
            Christian Da-Costa is a qualified Dispensing Optician holding a Bachelor of Science (BSc) degree. He specialises in helping patients achieve optimal vision through the accurate dispensing of optical lenses and frames tailored to individual needs.
          </p>
          <p style={{ color: C.muted, fontSize: '0.93rem', lineHeight: 1.9, marginBottom: '16px', fontWeight: 300 }}>
            With a strong background in optical science and patient care, Christian is committed to providing professional guidance on eyewear selection, lens options, and visual comfort — combining technical expertise with excellent customer service.
          </p>
          <p style={{ color: C.muted, fontSize: '0.93rem', lineHeight: 1.9, marginBottom: '36px', fontWeight: 300 }}>
            Every patient at Eye-Sight Care &amp; Optical receives the best possible visual solution — personalised, precise, and professional.
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '11px' }}>
            {POINTS.map((pt, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ color: C.blue, flexShrink: 0 }}><CheckIcon s={15} /></div>
                <span style={{ fontSize: '0.87rem', color: '#4A5568' }}>{pt}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Image side */}
        <div style={{ position: 'relative' }}>
          <div style={{
            borderRadius: '4px', overflow: 'hidden',
            boxShadow: '0 24px 60px rgba(26,68,128,0.12)',
            border: '1px solid rgba(26,68,128,0.07)',
            aspectRatio: '4/5',
          }}>
            <img
              src="/images/doctor.jpg"
              alt="Eye-Sight Optician"
              style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top center' }}
            />
          </div>
          <div style={{
            position: 'absolute', top: '24px', left: '-20px',
            border: '1px solid rgba(200,169,110,0.28)',
            borderRadius: '4px', width: '80%', height: '84%',
            pointerEvents: 'none', zIndex: 0,
          }} />
        </div>
      </div>
    </section>
  );
}
